<template>
  <div class="invite">
    <h1>
      {{ title || $t('organizations.invite_users.title') }}
    </h1>
    <div class="main">
      <div class="inner">
        <div class="invite-header">
          <slot name="invite-header" />
          <api-errors :errors="errors" />
        </div>
        <div class="invite-body">
          <slot name="invite-body" />
        </div>
        <div class="invite-footer">
          <slot name="invite-footer">
            <primary-button
              v-loading.fullscreen.lock="primaryLoading"
              :disabled="!canSubmit"
              @click.native="handleButtonClick">
              {{ successButtonLabel || $t('common.import') }}
            </primary-button>
            <tertiary-button
              @click.native="backToUsers">
              {{ cancelButtonLabel || $t('common.cancel') }}
            </tertiary-button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import ApiErrors from '@/components/common/ApiErrors'

  export default {
    components: {
      PrimaryButton,
      TertiaryButton,
      ApiErrors
    },
    props: {
      errors: {
        type: Object,
        default: () => {},
      },
      successButtonLabel: {
        type: String,
        default: null,
      },
      cancelButtonLabel: {
        type: String,
        default: null
      },
      handleSuccessButtonClick: {
        type: Function,
        default: () => {},
       },
       title: {
         type: String,
       },
       canSubmit: {
        type: Boolean,
        default: false,
       },
       backToUsers: {
         type: Function,
         default: () => { this._backToUsers() }
       },
       primaryLoading: {
         type: Boolean,
         default: false,
       }
    },
    methods: {
      _backToUsers() {
        this.$emit('toggle-organization-nav', true)
        this.$emit('invite-users', 'users')
        this.$emit('closed')
      },
      async handleButtonClick() {
        return await this.handleSuccessButtonClick()
      }
    },
  }
</script>

<style lang="scss" scoped>
@import '../../../scss/colors';

.invite {
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: $purple;

    border-bottom: none;
  }
}

.main {
  margin-top: 34px;
  background: white;

  .inner {
    padding: 40px 32px 64px 32px;
    display: flex;
    flex-direction: column;
  }

  .invite-header {
    padding-bottom: 48px;

    h3 {
      font-size: 18px;
    }
  }

  .invite-body {
    h4 {
      margin-top: 0;
      margin-bottom: 8px;
      color: $dark-blue-2;
    }
  }

  .invite-footer {
    ::v-deep .elsa-button {
      margin-left: 0;
    }
  }
}
</style>
